import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  preScreenGridRowsData: {}
};

export const preScreenGridRowsData = createSlice({
  name: 'preScreenGridRowsData',
  initialState,
  reducers: {
    clearPreScreenGridRowsData: state => {
      state.preScreenGridRowsData = {};
    },
    setPreScreenGridRowsData: (state, action: PayloadAction<any>) => {
      state.preScreenGridRowsData = action.payload;
    }
  }
});

export const { clearPreScreenGridRowsData, setPreScreenGridRowsData } = preScreenGridRowsData.actions;
